var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInventoryIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 17H7V19H12V17Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 17H18V19H23V17Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 7H12.5V9H17.5V7Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29 20H27V11C27 10.7348 26.8946 10.4804 26.7071 10.2929C26.5196 10.1054 26.2652 10 26 10H21.5V1C21.5 0.734784 21.3946 0.48043 21.2071 0.292893C21.0196 0.105357 20.7652 0 20.5 0H9.5C9.23478 0 8.98043 0.105357 8.79289 0.292893C8.60536 0.48043 8.5 0.734784 8.5 1V10H4C3.73478 10 3.48043 10.1054 3.29289 10.2929C3.10536 10.4804 3 10.7348 3 11V20H1C0.734784 20 0.48043 20.1054 0.292893 20.2929C0.105357 20.4804 0 20.7348 0 21V25C0 25.2652 0.105357 25.5196 0.292893 25.7071C0.48043 25.8946 0.734784 26 1 26H2V29C2 29.2652 2.10536 29.5196 2.29289 29.7071C2.48043 29.8946 2.73478 30 3 30H8C8.26522 30 8.51957 29.8946 8.70711 29.7071C8.89464 29.5196 9 29.2652 9 29V26H21V29C21 29.2652 21.1054 29.5196 21.2929 29.7071C21.4804 29.8946 21.7348 30 22 30H27C27.2652 30 27.5196 29.8946 27.7071 29.7071C27.8946 29.5196 28 29.2652 28 29V26H29C29.2652 26 29.5196 25.8946 29.7071 25.7071C29.8946 25.5196 30 25.2652 30 25V21C30 20.7348 29.8946 20.4804 29.7071 20.2929C29.5196 20.1054 29.2652 20 29 20ZM25 20H16V12H18V14C18 14.2652 18.1054 14.5196 18.2929 14.7071C18.4804 14.8946 18.7348 15 19 15H22C22.2652 15 22.5196 14.8946 22.7071 14.7071C22.8946 14.5196 23 14.2652 23 14V12H25V20ZM21 12V13H20V12H21ZM14.5 2H15.5V3H14.5V2ZM12.5 2V4C12.5 4.26522 12.6054 4.51957 12.7929 4.70711C12.9804 4.89464 13.2348 5 13.5 5H16.5C16.7652 5 17.0196 4.89464 17.2071 4.70711C17.3946 4.51957 17.5 4.26522 17.5 4V2H19.5V10H10.5V2H12.5ZM10 12V13H9V12H10ZM5 12H7V14C7 14.2652 7.10536 14.5196 7.29289 14.7071C7.48043 14.8946 7.73478 15 8 15H11C11.2652 15 11.5196 14.8946 11.7071 14.7071C11.8946 14.5196 12 14.2652 12 14V12H14V20H5V12ZM7 28H4V26H7V28ZM26 28H23V26H26V28ZM28 24H2V22H28V24Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryIcon);
export default __webpack_public_path__ + "static/media/inventory_icon.7242de73958bf417efc20dfbc5fb0012.svg";
export { ForwardRef as ReactComponent };